import { useCases } from "../../providers/Cases";
import { useCategories } from "../../providers/Categories";
import { usePosts } from "../../providers/Posts";
import Heart from "../heart/Heart";
import { Box, Case, CaseDiv, Container } from "./caseDisplayStyle";

const CaseDisplay = () => {
  const { colors } = useCategories();
  const { degCaseCalc, actualCases, getCaseToShow } = useCases();
  const { actualPost } = usePosts();

  return (
    <>
      <Container>
        <Box>
          <Heart textDisplay={actualPost.title.rendered} />
        </Box>
        <div>
          {actualCases.map((postCase, index) => {
            let colorNumber = JSON.parse(JSON.stringify(index));

            if (index > 8) {
              colorNumber -= 8;
            }

            return (
              <CaseDiv
                onClick={() => getCaseToShow(postCase.id)}
                id={`case${postCase.id}`}
                key={postCase.id}
                $degCaseCalc={degCaseCalc}
                $index={index}
              >
                <Case
                  color={colors[colorNumber]}
                  style={{ rotate: `-${degCaseCalc * index}deg` }}
                >
                  <p>{postCase.title.rendered}</p>
                </Case>
              </CaseDiv>
            );
          })}
        </div>
      </Container>
    </>
  );
};

export default CaseDisplay;
